import React, { useEffect, useMemo, useState } from "react";
import {
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap";
import { ITemplate } from "../../../types/template";
import { IUser } from "../../../types/user";
import { buildTemplatePayload } from "../../../types/templateVariables";


interface Props {
  template: ITemplate;
  onSend: (payload: any) => void;
}

interface Variable {
  key: string;
  label: string;
  example?: string;
}

interface DataTypes {
  name: string | null;
  named1: string | null;
  named2: string | null;
}

interface TemplateProps {
  isOpen: boolean;
  user: IUser | null;
  template: ITemplate;

  onClose: () => void;
  onChange: (values: Record<string, string>) => void;
  onSend: (payload: any) => void;
}

const TemplateModal = ({ user, isOpen, template, onChange, onClose, onSend }: TemplateProps) => {
  const [error, setError] = useState("");
  const [data, setData] = useState<DataTypes>({
    name: null,
    named1: null,
    named2: null,
  });
  // useEffect(() => {
  //   setData({
  //     name: null,
  //     named1: null,
  //     named2: null,
  //   });
  // }, []);

  const onChangeData = (field: "name" | "named1" | "named2", value: string) => {
    let modifiedData: DataTypes = { ...data };
    if (value === "") {
      modifiedData[field] = null;
    } else {
      modifiedData[field] = value;
    }
    setData(modifiedData);
  };


  // 🔍 Extrai variáveis do template
  // const variables: Variable[] = useMemo(() => {
  //   if (!body?.text) return [];

  //   // POSITIONAL → {{1}}, {{2}}
  //   if (template.parameter_format === "POSITIONAL") {
  //     const matches = body.text.match(/{{\d+}}/g) || [];
  //     const unique = Array.from(new Set(matches));

  //     return unique.map(v => ({
  //       key: v.replace(/[{}]/g, ""),
  //       label: `Variável ${v}`,
  //     }));
  //   }

  //   // NAMED → {{name}}
  //   if (template.parameter_format === "NAMED") {
  //     return (
  //       body.example?.body_text_named_params?.map((p: any) => ({
  //         key: p.param_name,
  //         label: `Variável {{${p.param_name}}}`,
  //         example: p.example,
  //       })) || []
  //     );
  //   }

  //   return [];
  // }, [template, data]);

  // 🧪 Preview do texto BODY
  // const previewBody = useMemo(() => {
  //   if (!body?.text) return "";

  //   return body.text.replace(/{{(.*?)}}/g, (_, k) => {
  //     return values[k] || `{{${k}}}`;
  //   });
  // }, [body, values]);

  const handleSend = (data: any) => {

    // const variables: Variable[] = [
    //   {
    //     key: '1',
    //     label: data.named1 ?? "label1",
    //     example: data.named1 ?? "",
    //   },
    //   {
    //     key: '2',
    //     label: data.named2 ?? "label1",
    //     example: data.named2 ?? "",
    //   },
    // ];

    const payload = buildTemplatePayload({
      to: "5511999999999",
      templateName: data.name as string,
      language: 'pt_BR',
      parameterFormat: 'POSITIONAL',
      variables: {
        key: '1',
        label: data.named1 ?? "label1",
        example: data.named1 ?? "",
      }
    });

    onSend(payload);
  };

  // if (!body?.text) {
  //   return <div className="text-muted">Template sem BODY</div>;
  // }

  const previewText = useMemo(() => {
    const body = template.components.find((c: any) => c.type === "BODY");
    if (!body?.text) return "";

    let text = body.text;

    // POSITIONAL → {{1}}, {{2}}
    if (template.parameter_format === "POSITIONAL") {
      const positionalMap: Record<string, string> = {
        "1": data.named1 ?? `{{1}}`,
        "2": data.named2 ?? `{{2}}`,
      };

      Object.entries(positionalMap).forEach(([key, value]) => {
        text = text.replaceAll(`{{${key}}}`, value);
      });
    }

    // NAMED → {{name}}, {{cliente}}, etc
    if (template.parameter_format === "NAMED") {
      const namedMap: Record<string, string> = {
        name: data.name ?? `{{name}}`,
        named1: data.named1 ?? `{{named1}}`,
        named2: data.named2 ?? `{{named2}}`,
      };

      Object.entries(namedMap).forEach(([key, value]) => {
        text = text.replaceAll(`{{${key}}}`, value);
      });
    }

    return text;
  }, [template, data]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => null} //{onClose} //Clica parte de fora para fechar
      tabIndex={-1}
      centered
      className="audiocallModal"
      contentClassName="shadow-lg border-0"
    >
      <ModalHeader toggle={onClose} className="bg-primary">
        <div className="modal-title-custom text-white font-size-16 ">
          Novo Contato
        </div>
      </ModalHeader>

      <ModalBody className="p-4">
        <Form>
          <div className="mb-3">
            <Label htmlFor="AddTemplateModal-name-input" className="form-label">
              Nome do Template
            </Label>
            <Input
              type="tel"
              className="form-control"
              id="AddTemplateModal-name-input"
              placeholder="5511912341122"
              value={data["name"] || ""}
              onChange={(e: any) => {
                onChangeData("name", e.target.value);
              }}
            />
          </div>
          <div className="mb-3">
            <Label htmlFor="AddTemplateModal-named2-input" className="form-label">
              Nome do Cliente
            </Label>
            <Input
              type="text"
              className="form-control"
              id="AddTemplateModal-named1-input"
              placeholder="Nome do Cliente"
              value={data["named1"] || ""}
              onChange={(e: any) => {
                onChangeData("named1", e.target.value);
              }}
            />
          </div>
          <div className="">
            <Label
              htmlFor="AddTemplateModal-named2-input"
              className="form-label"
            >
              Protocolo
            </Label>
            <textarea
              value={data["named2"] || ""}
              onChange={(e: any) => {
                onChangeData("named2", e.target.value);
              }}
              className="form-control"
              id="AddTemplateModal-named2-input"
              rows={3}
              placeholder="Olá, Podemos falar no momento?"
            ></textarea>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}


          {/* 🧪 PREVIEW */}
          <div
            className="mt-4 w-full border"
            style={{
              background: "#dcf8c6",
              padding: 12,
              borderRadius: 10,
              marginTop: 8,
              width: "100%",
              boxShadow: "0 1px 2px rgba(0,0,0,.15)",
              fontSize: 14,
            }}
          >
            {/* HEADER */}
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 6,
              }}
            >
              ZCred
            </div>

            {/* BODY */}
            <pre
              style={{
                whiteSpace: "pre-wrap",
                margin: 0,
                fontFamily: "inherit",
              }}
            >
              {previewText}
            </pre>

            {/* FOOTER */}
            <div
              style={{
                marginTop: 8,
                fontSize: 12,
                opacity: 0.7,
              }}
            >
              Prazer em atendê-lo sempre
            </div>
          </div>


        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="link" className="btn" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          type="button"
          color="primary"
          // disabled={!validate}
          onClick={() => handleSend(data)}
        >
          Enviar
        </Button>
      </ModalFooter>

    </Modal>
  );
};

export default TemplateModal;